import { HttpInterceptorFn } from '@angular/common/http';

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  if (['GET', 'HEAD', 'OPTIONS'].includes(req.method.toUpperCase())) {
    return next(req);
  }
  const token = document.cookie.match(/(^| )XSRF-TOKEN=([^;]+)/)?.[2];
  return next(
    token
      ? req.clone({
          headers: req.headers.set('X-XSRF-TOKEN', decodeURIComponent(token)),
        })
      : req,
  );
};
